export const configTypeMap = {
  sportsBook: 'sportsBook',
  casino: 'casino',
  virtualGames: 'virtualGames',
  virtuals: 'virtuals',
};

export const eventMap = {
  boosted: 'boostedOdds',
  today: 'today',
  multiples: 'multiplesOfTheDay',
};
